import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';

import { Link } from 'react-router-dom';
import Leftsidebarindustry from '../components/Leftsidebarindustry';
import Indusrtypagebanner from '../components/Indusrtypagebanner';
function Pharmaceutical() {
  return (
    <div>
     <Header/>
        <Indusrtypagebanner/>

             <div className="service-details-section sp1">
    <div className="container">
        <div className="row">
            <Leftsidebarindustry/>

            <div className="col-lg-8">
                <div className="service-main-content heading1 padding1">
                    <h2>Pharmaceutical Industry</h2>
                    <div className="space16"></div>
                   
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/industry/Industry_Focus/Pharmaceutical_Industry.png" alt=""/>
                    </div>
                    <div className="space32"></div>
                  
                    <div className="space16"></div>
                     <p>In the ever-evolving pharmaceutical sector, precision, compliance, and expertise are everything. </p>
                    <div className="space16"></div>
                    <p>JBY Talent Acquisition & Management Private Limited delivers targeted pharma recruitment solutions tailored for roles in research & development (R&D), quality assurance, regulatory affairs, medical writing, and production.
                    We help pharmaceutical companies maintain strict regulatory compliance by hiring professionals with industry-specific certifications and scientific knowledge. </p>
                    <div className='space32'></div>
                    <p>With a strong network across pharma hubs in India, we bridge the talent gap by connecting innovation-driven companies with skilled and ethical professionals who can contribute to breakthrough discoveries and consistent production quality.</p>
                    <div className="space32"></div>
                  
                   <div className="space32"></div>
                 
                </div>
            </div>
        </div>
    </div>
</div>
        <Footer/>
      
    </div>
  )
}

export default Pharmaceutical
